import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SampleService } from 'src/app/core/http/sample.service';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-add-qc-modal',
  templateUrl: './add-qc-modal.component.html',
  styleUrls: ['./add-qc-modal.component.scss'],
})
export class AddQcModalComponent implements OnInit {
  isLoading = false;
  Errors = null;
  data = null;
  mode = 'add';
  Success = null;
  valuesCount: any[] = [];
  sampleId = '';
  paramName = '';
  paramUnit = '';
  paramValue = 0;
  timestamp = '';
  dateStart = '';
  dateEnd = '';

  qcForm = new FormGroup({
    Id: new FormControl(0),
    Name: new FormControl('', Validators.required),
    Unit: new FormControl('', Validators.required),
    Min: new FormControl('', Validators.required),
    Max: new FormControl('', Validators.required),
    Normal: new FormControl('', Validators.required),
    StartDate: new FormControl('', Validators.required),
    StopDate: new FormControl('', Validators.required),
    QcValues: new FormControl(this.valuesCount, Validators.required),
    QcValuesCount: new FormControl('', Validators.required),
  });

  constructor(
    private modal: ModalService,
    private sample: SampleService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}
  ngOnInit(): void {}

  formatDate(date: Date): string {
    return moment(date).toISOString();
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Id,
      Name,
      Unit,
      Min,
      Max,
      Normal,
      StartDate,
      StopDate,
      QcValues,
      QcValuesCount,
    } = this.qcForm.value;
    const formattedStartDate = moment(StartDate).toISOString();
    const formattedStopDate = moment(StopDate).toISOString();
    this.sample
      .addQc(
        Id,
        Name,
        Unit,
        Min,
        Max,
        Normal,
        formattedStartDate,
        formattedStopDate,
        QcValues,
        QcValuesCount
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.modal.closeModal();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }
  back() {
    this.mode = 'add';
  }
  next() {
    this.mode = 'values';
  }
  // addValues() {
  //   if (
  //     this.sampleId === '' ||
  //     this.paramName === '' ||
  //     this.paramUnit === '' ||
  //     this.paramValue === 0 ||
  //     this.timestamp === ''
  //   ) {
  //     this._snackBar.open('Input all fields', '', {
  //       duration: 2000,
  //       verticalPosition: 'top',
  //     });
  //   } else {
  //     this.valuesCount.push({
  //       Id: 0,
  //       SampleId: this.sampleId,
  //       ParamName: this.paramName,
  //       ParamUnit: this.paramUnit,
  //       ParamValue: this.paramValue,
  //       Timestamp: moment(this.timestamp).toISOString(),
  //     });
  //     console.log(this.valuesCount);
  //     this.sampleId = '';
  //     this.paramName = '';
  //     this.paramUnit = '';
  //     this.paramValue = 0;
  //     this.timestamp = '';
  //   }
  // }

  // deleteItem(value) {
  //   console.log(this.valuesCount);
  //   this.valuesCount = this.valuesCount.filter((t) => t.ParamName !== value);
  // }
}
